module.exports = __webpack_public_path__ + "img/South African Express.8ae900dd.png";